// Shared money formatter for every dashboard widget. Output format is load-bearing: widget tests assert
// strings like '1,100.00', so any change here is a breaking change to those suites.

// The locale is pinned rather than left to the browser. With `undefined` the grouping and the
// digits followed whatever locale the viewer's browser reported, so the same figure rendered as
// '1,100.00' for one user, '1.100,00' for another, and in Bengali numerals with lakh/crore
// grouping under bn-BD — while every test (and the invoice PDF) assumed en-US. Money on the
// dashboard has to tie out against documents, so the format is fixed here.
const MONEY_LOCALE = 'en-US';

/** The only currency this product bills and reports in (bKash/BDT, AmountInWords, invoice PDFs). */
export const CURRENCY_SYMBOL = '৳';

export function fmtMoney(n: number): string {
    return n.toLocaleString(MONEY_LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
